import { Option } from '@trukt/portal-utils/Option';
import { DateLiterals } from '@api';
import { CompoundFilterItemsState } from './useCompoundFilterItems.types';

export const INITIAL_COMPOUND_FILTER_ITEMS_STATE: CompoundFilterItemsState = {
  addressCriteria: '',
  miles: '',
  dateFilter: {
    dateOption: { label: '', value: '' },
    date: { startDate: undefined, endDate: undefined },
  },
};

export const MOCKED_DATE_OPTIONS: Option<DateLiterals>[] = [
  {
    label: 'Created On',
    value: 'created',
  },
  {
    label: 'Submitted On',
    value: 'submitted',
  },
  {
    label: 'Scheduled Pickup',
    value: 'scheduled pick up',
  },
  {
    label: 'Scheduled Delivery',
    value: 'scheduled delivery',
  },
  {
    label: 'Picked Up On',
    value: 'picked up',
  },
  {
    label: 'Delivered On',
    value: 'completed',
  },
  {
    label: 'Canceled',
    value: 'canceled',
  },
];
